// John Eldhose 201800613
import { RestfulGet } from './Restful';

export async function getProfile() {
  const prof = await RestfulGet('getProfile', (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return prof;
}



// WEBPACK FOOTER //
// ./src/Api/getProfile.js